interface InternalJobIdBadgeProps {
	internalJobId: string;
}

const InternalJobIdBadge = ({ internalJobId }: InternalJobIdBadgeProps) => {
	return (
		<span className="inline-flex items-center rounded-md bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">
			Internal ID: {internalJobId}
		</span>
	);
};

export default InternalJobIdBadge;
